import React from 'react';
import { Skeleton } from '@material-ui/lab';

const PhotoDetailsModalSkeleton = () => (
  <div className="w-100 d-flex flex-column pb-4">
    {/* Image */}
    <Skeleton
      animation="wave"
      variant="rect"
      width="100%"
      height={320}
    />

    <div className="w-100 d-flex flex-column pt-2 px-4">
      {/* Author */}
      <div className="d-flex align-items-center">
        <Skeleton variant="circle" width={24} height={24} />
        <Skeleton
          animation="wave"
          width={120}
          height={18}
          style={{ marginLeft: 8 }}
        />
      </div>

      {/* Location */}
      <div className="d-flex flex-column align-items-center pt-3 px-3">
        <Skeleton width={180} height={20} className="mb-2" />
        <Skeleton
          animation="wave"
          variant="rect"
          width="100%"
          height={180}
          style={{ borderRadius: 8 }}
        />
      </div>

      {/* Date */}
      <div className="d-flex flex-column align-items-center mt-5">
        <Skeleton width={110} height={20} />
        <Skeleton
          animation="wave"
          variant="rect"
          width={180}
          height={40}
          style={{ borderRadius: 4 }}
        />
      </div>

      {/* Description */}
      <div className="w-100 d-flex flex-column align-items-center mt-3 px-3">
        <Skeleton width={90} height={20} />
        <Skeleton width={150} height={16} />

        <Skeleton
          animation="wave"
          variant="rect"
          width="100%"
          height={150}
          style={{ borderRadius: 8 }}
        />
      </div>

      {/* Tags */}
      <div className="w-100 d-flex flex-column align-items-center mt-3 px-3">
        <Skeleton width={60} height={20} />
        <Skeleton width={170} height={16} />

        <div className="w-100 d-flex flex-wrap mt-2">
          {[1, 2, 3, 4].map((item) => (
            <Skeleton
              key={item}
              animation="wave"
              variant="rect"
              width={70}
              height={30}
              style={{
                borderRadius: 16,
                marginRight:  8,
                marginBottom: 8,
              }}
            />
          ))}
        </div>
      </div>
    </div>

    {/* Update button */}
    <div className="mb-4 mt-4 d-flex justify-content-center">
      <Skeleton
        animation="wave"
        variant="rect"
        width={140}
        height={40}
        style={{ borderRadius: 20 }}
      />
    </div>
  </div>
);

export default PhotoDetailsModalSkeleton;
